(function () {
  const STOQ_INTENTS_URL_PART = "/api/v1/intents.json";

  function fireMetaEvent(payload) {
    if (typeof window.fbq !== "function") return; // Meta Pixel not loaded yet

    const intent = payload?.intent || {};
    const customer = payload?.customer || {};
    const product = payload?.product || {};

    // Use a stable event name for custom conversions/audiences in Meta
    window.fbq("trackCustom", "STOQ_BackInStock_Submit", {
      content_type: "product",
      content_ids: intent.shopify_variant_id ? [String(intent.shopify_variant_id)] : undefined,
      shopify_product_id: intent.shopify_product_id ? String(intent.shopify_product_id) : undefined,
      channel: intent.channel, // email / sms
      quantity: intent.quantity,
      email: customer.email, // consider removing if you want to avoid sending PII in browser event params
      product_title: product.title,
      variant_title: product.variant_title,
      sku: product.sku,
      vendor: product.vendor
    });
  }

  // 1) Intercept fetch
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async function (input, init) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const method = (init && init.method) || (input && input.method) || "GET";

      // Only inspect STOQ create intent requests
      const isStoqCreateIntent =
        method.toUpperCase() === "POST" && url.includes(STOQ_INTENTS_URL_PART);

      let requestBodyJson = null;

      if (isStoqCreateIntent) {
        try {
          const body = init && init.body;
          if (typeof body === "string") requestBodyJson = JSON.parse(body);
        } catch (e) {}
      }

      const response = await originalFetch.apply(this, arguments);

      if (isStoqCreateIntent && response && (response.status === 201 || response.status === 200)) {
        // STOQ docs show 201 for success, 200 can happen with errors array. :contentReference[oaicite:2]{index=2}
        // We'll only fire if it looks like a success (no "errors" in JSON).
        try {
          const cloned = response.clone();
          const data = await cloned.json().catch(() => null);

          if (!data || (Array.isArray(data.errors) && data.errors.length)) return;

          // Prefer the actual request body (it has variant/product ids), fallback to response
          fireMetaEvent(requestBodyJson || data);
        } catch (e) {}
      }

      return response;
    };
  }

  // 2) (Optional) also listen for STOQ embed being loaded
  window.addEventListener("stoq:loaded", function (event) {
    // STOQ emits this when app embed loads. :contentReference[oaicite:3]{index=3}
    // Useful if you want to add extra checks/logging.
    // console.log("STOQ loaded", event.detail);
  });
})();
